import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import {
  fetchSapAuditStats,
  fetchSapAuditLogs,
  fetchSapAuditDetail,
  setSapAuditFilters,
  resetSapAuditFilters,
  clearSapAuditDetail,
  setSapAuditPage,
  setSapAuditPageSize,
} from '../../../containers/actions/common/sapAuditActions';
import { buildApiPayload, getDefaultFilters } from './utils';
import SummaryCards from './SummaryCards';
import FilterBar from './FilterBar';
import MessageTable from './MessageTable';
import DetailPanel from './DetailPanel';
import { useStyles } from './styles';

const SapAuditDashboard = (props) => {
  const {
    stats, logs, filters, total, page, pageSize,
    detail, statsLoading, logsLoading, detailLoading,
    fetchSapAuditStats, fetchSapAuditLogs, fetchSapAuditDetail,
    setSapAuditFilters, resetSapAuditFilters, clearSapAuditDetail,
    setSapAuditPage, setSapAuditPageSize,
  } = props;

  const classes = useStyles();
  const [detailOpen, setDetailOpen] = useState(false);

  useEffect(() => {
    const defaultFilters = getDefaultFilters();
    setSapAuditFilters(defaultFilters);
    fetchSapAuditStats(buildApiPayload(defaultFilters));
    fetchSapAuditLogs(buildApiPayload(defaultFilters, { page: 1, pageSize: 50 }));
  }, []);

  const handleFilterChange = (newFilters) => {
    const merged = { ...filters, ...newFilters };
    setSapAuditFilters(merged);
    setSapAuditPage(1);
    fetchSapAuditStats(buildApiPayload(merged));
    fetchSapAuditLogs(buildApiPayload(merged, { page: 1, pageSize }));
  };

  const handleReset = () => {
    const defaultFilters = getDefaultFilters();
    resetSapAuditFilters();
    fetchSapAuditStats(buildApiPayload(defaultFilters));
    fetchSapAuditLogs(buildApiPayload(defaultFilters, { page: 1, pageSize }));
  };

  const handlePageChange = (newPage) => {
    setSapAuditPage(newPage);
    fetchSapAuditLogs(buildApiPayload(filters, { page: newPage, pageSize }));
  };

  const handlePageSizeChange = (newPageSize) => {
    setSapAuditPage(1);
    setSapAuditPageSize(newPageSize);
    fetchSapAuditLogs(buildApiPayload(filters, { page: 1, pageSize: newPageSize }));
  };

  const handleRowClick = (row) => {
    setDetailOpen(true);
    fetchSapAuditDetail(row.id);
  };

  const handleDetailClose = () => {
    setDetailOpen(false);
    clearSapAuditDetail();
  };

  return (
    <div className={classes.pageRoot}>
      <Typography variant='h5' className={classes.pageTitle}>
        SAP Message Audit
      </Typography>

      <SummaryCards stats={stats} loading={statsLoading} />

      <FilterBar
        filters={filters}
        onFilterChange={handleFilterChange}
        onReset={handleReset}
        loading={logsLoading}
      />

      <MessageTable
        data={logs}
        totalCount={total}
        pageIndex={page}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onRowClick={handleRowClick}
        loading={logsLoading}
      />

      <DetailPanel
        open={detailOpen}
        detail={detail}
        loading={detailLoading}
        onClose={handleDetailClose}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  stats: state.pcmp.common.sapAudit.stats,
  logs: state.pcmp.common.sapAudit.logs,
  filters: state.pcmp.common.sapAudit.filters,
  total: state.pcmp.common.sapAudit.total,
  page: state.pcmp.common.sapAudit.page,
  pageSize: state.pcmp.common.sapAudit.pageSize,
  detail: state.pcmp.common.sapAudit.detail,
  statsLoading: state.pcmp.common.sapAudit.statsLoading,
  logsLoading: state.pcmp.common.sapAudit.logsLoading,
  detailLoading: state.pcmp.common.sapAudit.detailLoading,
});

export default connect(mapStateToProps, {
  fetchSapAuditStats,
  fetchSapAuditLogs,
  fetchSapAuditDetail,
  setSapAuditFilters,
  resetSapAuditFilters,
  clearSapAuditDetail,
  setSapAuditPage,
  setSapAuditPageSize,
})(SapAuditDashboard);
